import { useParams } from "react-router-dom";

const Test = () => {

  const data = useParams();

  const { type, location, zone } = data;

  const path = [type,location,zone].filter(Boolean).join("/")

  console.log(data, path);

  return (
    <>
      <h1>Comman page</h1>
      <h3>{type}</h3>
      {location && <h3>{location}</h3>}
      {zone && <h3>{zone}</h3>}

      <pre>
    {JSON.stringify({type,location,zone},null,2)}
      </pre>
    </>
  );
};

export default Test
